import React from 'react';
import { activities } from '@zipdrug/react-api-sdk';
import { alertOnError } from '@zipdrug/ui';
import { omit } from 'lodash';
import { graphql } from 'react-apollo';

export default Component => {
  const WithMutation = graphql(activities.mutateCreateDelivery, { name: 'mutateCreateDelivery' })(Component);
  
  return React.forwardRef((props, ref) => {
    const onCreateDelivery = async values =>
      alertOnError(
        props.mutateCreateDelivery({
          variables: values,
        }),
      );
    
    const propsWithoutMutation = omit(props, 'mutateCreateDelivery');
    
    return <WithMutation {...propsWithoutMutation} onCreateDelivery={onCreateDelivery} ref={ref} />;
  });
};
